import {Howl} from "howler";
import * as PIXI from "pixi.js";
import {config} from "../config";
import data from "./configs/data";
import {Button} from "./controlElements/Button";
import {CustomSpineAnimation} from "./CustomSpineAnimation";

export class ResultModal extends PIXI.Container {

    private readonly DEFAULT_ANCHOR_POINT: any = new PIXI.Point(0.5, 0.5);

    private readonly ANIMATION_CONFIG: any = {
        NAME: "result",
        STATES: {
            RESULT: "result",
            RESULT_IDLE: "result_idle",
            RESULT_WIN: "result_win",
            RESULT_WIN_IDLE: "result_win_idle",
            WAITING: "waiting",
        },
        SLOT_CONTAINERS: {
            FRAME: "frame",
            DICE_RESULT: "dice_result",
        },
    };

    private readonly DRAWN_NUMBER_TEXT_STYLE = {
        fontSize: 56,
        fontFamily: "RobotoBold",
        fontWeight: "700",
        fill: "#000000",
    };

    private readonly PRIZE_TEXT_STYLE = {
        fontSize: 46,
        fontFamily: "RobotoRegular",
        fill: "#fff",
    };

    private resultAnimation: CustomSpineAnimation;
    private drawnNumberPixiText: PIXI.Text;
    private prizePixiText: PIXI.Text;
    private resultShown = false;

    private noWinSound: Howl;
    private winSound: Howl;
    private waitingSound: Howl;
    private promiseResolve: any;
    private endingTimeout: any;

    constructor() {
        super();
        this.createAndAddBackgroundBlend();
        this.createAndAddResultAnimation();
        this.hide();

        this.noWinSound = new Howl({
            src: [data.audios.resultSound],
        });
        this.winSound = new Howl({
            src: [data.audios.resultAndWinSound],
        });
        this.waitingSound = new Howl({
            src: [data.audios.waitingSound],
        });
    }

    public show(): void {
        this.visible = true;
    }

    public hide(): void {
        this.visible = false;
    }

    public showLoadingAnimation(): void {
        this.resultShown = false;
        this.resultAnimation.play(this.ANIMATION_CONFIG.STATES.WAITING, true);
        this.waitingSound.play();
        this.resultAnimation.addOnCompleteListener(() => {
            this.waitingSound.play();
        });
    }

    public async showResult(drawnNumber: number, prize: number, currencyType: string): Promise<any> {
        this.resultAnimation.removeAllListenersMyCopy();
        return new Promise((resolve) => {
            this.promiseResolve = resolve;
            this.resultAnimation.addOnCompleteListener(() => {
                this.drawnNumberPixiText.text = "" + drawnNumber;
                this.prizePixiText.text = prize.toFixed(config.betDisplayPrecision + 1) + " " + config.displayCurrency;
                if (prize > 0) {
                    this.resultAnimation.play(this.ANIMATION_CONFIG.STATES.RESULT_WIN);
                    this.winSound.play();
                } else {
                    this.resultAnimation.play(this.ANIMATION_CONFIG.STATES.RESULT);
                    this.noWinSound.play();
                }
                this.resultAnimation.removeAllListenersMyCopy();
                this.resultAnimation.addOnCompleteListener(async () => {
                    this.resultAnimation.removeAllListenersMyCopy();
                    this.resultShown = true;
                    this.endingTimeout = setTimeout(() => {
                        this.tryResolvePromise();
                    }, 1400);
                });
            });
        });
    }

    private createAndAddResultAnimation(): void {
        this.resultAnimation = new CustomSpineAnimation(this.ANIMATION_CONFIG.NAME);
        this.drawnNumberPixiText = new PIXI.Text("", this.DRAWN_NUMBER_TEXT_STYLE);
        this.drawnNumberPixiText.anchor = this.DEFAULT_ANCHOR_POINT;
        this.drawnNumberPixiText.scale.y = -1;
        this.resultAnimation.getSlotContainer(this.ANIMATION_CONFIG.SLOT_CONTAINERS.DICE_RESULT)
            .addChild(this.drawnNumberPixiText);
        (window as any).drawnNumberPixiText = this.drawnNumberPixiText;
        this.prizePixiText = new PIXI.Text("", this.PRIZE_TEXT_STYLE);
        this.prizePixiText.anchor = this.DEFAULT_ANCHOR_POINT;
        this.prizePixiText.scale.y = -1;
        this.resultAnimation.getSlotContainer(this.ANIMATION_CONFIG.SLOT_CONTAINERS.FRAME)
            .addChild(this.prizePixiText);
        (window as any).prizePixiText = this.prizePixiText;

        this.addChild(this.resultAnimation);
    }

    private createAndAddBackgroundBlend(): void {
        const graphics = new PIXI.Graphics();
        graphics.beginFill(0x000000, 0.8);
        graphics.drawRect(-500, -300,
            1000, 600);
        graphics.endFill();
        const backgroundBlend = new PIXI.Sprite(graphics.generateCanvasTexture());
        backgroundBlend.anchor = this.DEFAULT_ANCHOR_POINT;
        backgroundBlend.interactive = true;
        backgroundBlend.on(Button.BUTTON_EVENTS.POINTER_DOWN, () => {
            if (this.resultShown) {
                clearTimeout(this.endingTimeout);
                this.tryResolvePromise();
                this.hide();
            }
        });
        this.addChild(backgroundBlend);
    }

    private tryResolvePromise(): void {
        if (this.promiseResolve) {
            this.promiseResolve();
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/ResultModal.ts